import { CdkColumnDef } from '@angular/cdk/table';
import {
  Component,
  ElementRef,
  HostBinding,
  OnDestroy,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { ExportFilePopupComponent } from 'src/app/shared/components/export-file-popup/export-file-popup.component';
import { VesselStatusPopupComponent } from 'src/app/shared/components/vessel-status-popup/vessel-status-popup.component';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { DEMO_VESSEL_PC } from 'src/app/shared/helpers/heating-table-dynamic-extract.util';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-port-active-vessels',
  templateUrl: './port-active-vessels.component.html',
  styleUrls: ['./port-active-vessels.component.scss'],
})
export class PortActiveVesselsComponent implements OnDestroy {
  private static readonly BODY_SCROLL_CLASS = 'pc-fleet-view-scroll';
  @ViewChildren(CdkColumnDef) columnDefs!: QueryList<CdkColumnDef>;
  filterForm!: FormGroup;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('table', { static: false }) table!: ElementRef;
  // paginatedData: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 0;
  elements: any;
  counter = 1;
  segmentOptions = [
    'Bulk',
    'General Cargo',
    'Handymax',
    'LR1/Panamax',
    'LR2/Aframax',
    'LR3/Suezmax',
    'MR',
    'VLCC',
  ];
  selectedSegments: string[] = [];
  isFilterOpen = false;
  cargoOperation: any;
  filteredData: any;
  selectedTab: boolean | undefined;
  pastVoyagesComponent: any;
  data: any;
  shipNameSuggestions: any[] = [];
  edit: boolean = false;
  dataToPass: any;
  snackBar: any;
  sharedDataService: any;
  paginatedData: any;
  clientOptions: string[] = [];
  selectedClients: string[] = [];
  username: any;
  markers: L.Marker[] = [];
  map!: L.Map;
  private baseLayer!: L.TileLayer;
  positions: any;
  ships: any[] = [];
  subusername: any;
  isLoadingTable: boolean = true;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private requestFormService: RequestFormService,
    private prequestFormService: PortRequestFormServiceService,
  ) {
    this.filterForm = this.fb.group({
      from_date: ['', [Validators.required]],
      to_date: ['', [Validators.required]],
      shipName: ['', [Validators.required]],
      imoNumber: ['', [Validators.required]],
      cargoOperation: ['', [Validators.required]],
    });
    // this.segmentOptions = getSegmentOptions();
  }
  ngOnInit() {
    this.subusername = localStorage.getItem('loginPic') ?? '';
    document.body.classList.add(PortActiveVesselsComponent.BODY_SCROLL_CLASS);
    this.loadData();
    this.initMap();
    const savedFilters = localStorage.getItem('vesselFilters');
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);
      this.filterForm.patchValue(filters);
    }
  }

  ngOnDestroy() {
    document.body.classList.remove(
      PortActiveVesselsComponent.BODY_SCROLL_CLASS,
    );
  }
  getAisData() {
    const positions =
      this.subusername?.toLowerCase() === 'grace'
        ? this.positions.filter(
            (item: any) => String(item.vesselIMO) !== '9397456',
          )
        : this.positions;
    const imoNumbers = positions
      .map((item: any) => item.vesselIMO)
      .filter((imo: any) => !!imo);

    this.requestFormService.getkplerList(imoNumbers).subscribe({
      next: (res: any) => {
        const aisList = res.data || [];
        const aisMap = new Map();

        aisList.forEach((item: any) => {
          if (item.AIS?.IMO) {
            aisMap.set(String(item.AIS.IMO), item.AIS);
          }
        });

        this.positions = this.positions.map((ship: any) => ({
          ...ship,
          AIS: aisMap.get(String(ship.vesselIMO)) || null,
        }));

        this.ships = this.positions;
        this.allShips = [...this.ships];
        this.allFilteredData = Array.isArray(this.elements)
          ? [...this.elements]
          : [];

        // Re-apply client + At Port/Sea together (do not reset client filters)
        this.refreshFleetView(false);
      },
    });
  }
  // addMarkers(): void {
  //   this.markers.forEach(marker => marker.remove());
  //   this.markers = [];

  //   const navStatusMap: Record<number, string> = {
  //     0: 'Under Way',
  //     1: 'At Anchor',
  //     2: 'Not Under Command',
  //     3: 'Restricted Manoeuvrability',
  //     5: 'Moored'
  //   };

  //   const latestVessels: any = {};

  //   this.ships.forEach((item: any) => {
  //     const ais = item.AIS;

  //     const lat = ais?.LATITUDE
  //       ? Number(ais.LATITUDE)
  //       : Number(item.latitudeResult);

  //     const lng = ais?.LONGITUDE
  //       ? Number(ais.LONGITUDE)
  //       : Number(item.longitudeResult);

  //     if (!lat || !lng) return;

  //     const vessel = item.vesselName;
  //     const time = new Date(item.report_timestamp).getTime();

  //     if (
  //       !latestVessels[vessel] ||
  //       new Date(latestVessels[vessel].report_timestamp).getTime() < time
  //     ) {
  //       latestVessels[vessel] = {
  //         ...item,
  //         latitudeResult: lat,
  //         longitudeResult: lng
  //       };
  //     }
  //   });

  //   Object.values(latestVessels).forEach((res: any) => {
  //     const marker = L.marker(
  //       [res.latitudeResult, res.longitudeResult],
  //       {
  //         icon: this.createIcon(
  //           res.vesselName?.toUpperCase(),
  //           this.map.getZoom()
  //         )
  //       }
  //     );

  //     const signalOld =
  //       (Date.now() - new Date(res.AIS?.TIMESTAMP || Date.now()).getTime()) >
  //       21600000;

  //     marker.bindTooltip(
  //       `
  //       <div style="width:255px;border-radius:18px;overflow:hidden;background:white;box-shadow:0 18px 40px rgba(15,23,42,.18);font-family:Poppins;">
  //         <div style="padding:14px;background:linear-gradient(135deg,#0f172a,#1d4ed8,#38bdf8);color:white;">
  //           <div style="font-size:13px;font-weight:700;">
  //             🚢 ${res.vesselName}
  //           </div>
  //           <div style="margin-top:6px;font-size:10px;">
  //             ${signalOld ? '🔴 Delayed AIS Signal' : '🟢 Live Tracking'}
  //           </div>
  //         </div>

  //         <div style="padding:12px;font-size:11px;">
  //           <div><b>Destination:</b> ${res.AIS?.DESTINATION || '-'}</div>
  //           <div><b>Navigation:</b> ${navStatusMap[Number(res.AIS?.NAV_STATUS)] || '-'}</div>
  //           <div><b>Depth:</b> ${res.AIS?.DRAUGHT || '-'} m</div>
  //           <div><b>UTC:</b> ${res.AIS?.TIMESTAMP || '-'}</div>
  //         </div>
  //       </div>
  //       `,
  //       {
  //         direction: 'top',
  //         sticky: true,
  //         opacity: 1
  //       }
  //     );

  //     marker.addTo(this.map);
  //     this.markers.push(marker);
  //   });
  // }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  @HostBinding('class.pc-light') get pcLight(): boolean {
    return !this.isDarkMode();
  }

  get tooltipClass(): string {
    return this.isDarkMode()
      ? 'preformatted-tooltip'
      : 'preformatted-tooltip preformatted-tooltip--light';
  }

  refresh() {
    this.loadData();
  }
  loadData() {
    this.username = localStorage.getItem('username');
    this.isLoadingTable = true;
    this.prequestFormService.getFleetViewData('true').subscribe((data) => {
      const clientFilters: { [key: string]: (item: any) => boolean } = {
        'Eiger Shipping': (item) =>
          item.client &&
          (item.client === 'Northwell' ||
            item.client.toLowerCase() === 'eiger'),
        'Zeronorth ZN': (item) =>
          item.client && item.client.toLowerCase() === 'zeronorth',
        'Elite Shipping': (item) =>
          item.client &&
          (item.client.toLowerCase() === 'elite tankship dmcc' ||
            item.client.toLowerCase() === 'elite'),
        'Bunge Shipping': (item) =>
          item.client && item.client.toLowerCase() === 'bunge',
        'Alcor Shipping': (item) =>
          item.client &&
          (item.client.toLowerCase() === 'alcor chartering dmcc' ||
            item.client.toLowerCase() === 'alcor chartering'),
        'EMZoil Shipping': (item) =>
          item.client && (item.client.toLowerCase() === 'emz oil' || item.client.toLowerCase() === 'emzoil fzco'),
        'Ethiopian Shipping & Logistics': (item) =>
          item.client.toLowerCase() === 'ethiopian shipping & logistics',
      };
      if (this.username === 'Meraki - Operations') {
        data = data.data;
      } else if (clientFilters[this.username]) {
        data = data.data.filter(clientFilters[this.username]);
      } else {
        data = data.data ?? data;
      }
      if (this.subusername?.toLowerCase() === 'grace') {
        data = (Array.isArray(data) ? data : []).filter(
          (item: any) =>
            String(item.imo ?? item.vessel_imo ?? item.vessel_id) !== '9397456',
        );
      }
      this.elements = Array.isArray(data) ? data : [];

      if (this.subusername?.toLowerCase() === 'demo') {
        this.elements = this.elements
          .filter((item: any) =>
            DEMO_VESSEL_PC.includes(
              String(item.vessel_imo ?? item.imo ?? item.vessel_id),
            ),
          )
          .map((item: any) => {
            const originalImo = String(
              item.vessel_imo ?? item.imo ?? item.vessel_id,
            );

            return {
              ...item,

              // Keep original values for navigation/API
              original_vessel_imo: originalImo,
              original_vessel_name: item.vessel_name,

              // Mask values displayed in table
              vessel_imo: 'XXXXXXX',
              vessel_name: originalImo === '9399480' ? 'Vessel 1' : 'Vessel 2',
              client:originalImo === '9399480' ? 'Client 1' : 'Client 2',
            };
          });
      }

      // Create unique dropdown options
      // this.segmentOptions = [
      //   ...new Set(
      //     this.elements.map((item: any) => item.segment).filter(Boolean),
      //   ),
      // ];
      this.clientOptions = [
        ...new Set(
          this.elements.map((item: any) => item.client).filter(Boolean),
        ),
      ] as string[];
      const clientMap = new Map<string, string>();

      this.elements.forEach((item: any) => {
        if (!item.client) return;

        const originalName = item.client.trim();
        const key = this.normalizeClient(originalName);
        const existing = clientMap.get(key);

        const score = (name: string) => {
          let s = 0;
          if (/dmcc|ltd|llc|pvt|private|limited/i.test(name)) s += 5;
          s += name.split(' ').length;
          s += name.length / 100;
          return s;
        };

        if (!existing) {
          clientMap.set(key, this.toTitleCase(originalName));
          return;
        }

        if (score(originalName) > score(existing)) {
          clientMap.set(key, this.toTitleCase(originalName));
        }
      });

      this.clientOptions = Array.from(clientMap.values());
      this.refreshFleetView(false);
      this.isLoadingTable = false;
    });
  }
  toTitleCase(name: string): string {
    return name
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  normalizeClient(name: string): string {
    return (
      name
        ?.toLowerCase()
        .replace(/tankship|shipping|dmcc|ltd|llc|pvt|private|limited/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim() || ''
    );
  }

  clearClick() {
    this.filterForm.reset();
    this.selectedClients = [];
    this.selectedSegments = [];
    this.refreshFleetView(true);
  }

  filterShipNames(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length > 0) {
      this.shipNameSuggestions = this.elements.filter((item: any) =>
        item.vessel_name.toLowerCase().includes(inputValue),
      );
    } else {
      this.shipNameSuggestions = [];
    }
  }
  ngAfterViewInit() {
    this.sort?.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  paginateData() {
    const source = Array.isArray(this.filteredData)
      ? this.filteredData
      : Array.isArray(this.elements)
        ? this.elements
        : [];

    const startIndex = this.currentPage * this.itemsPerPage;

    this.paginatedData = source.slice(
      startIndex,
      startIndex + this.itemsPerPage,
    );
  }

  // paginateData() {
  //   const startIndex = this.currentPage * this.itemsPerPage;
  //   this.paginatedData = this.elements?.slice(
  //     startIndex,
  //     startIndex + this.itemsPerPage
  //   );
  // }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    this.paginatedData = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, isAsc, sort.active);
    });
  }

  compare(a: any, b: any, isAsc: boolean, column: string) {
    let valueA = this.getNestedValue(a, column);
    let valueB = this.getNestedValue(b, column);

    if (valueA === null || valueA === undefined) return isAsc ? -1 : 1;
    if (valueB === null || valueB === undefined) return isAsc ? 1 : -1;

    const numericalColumns = ['timeLost', 'hsfo', 'vlsfo', 'go'];
    if (numericalColumns.includes(column)) {
      valueA = parseFloat(valueA);
      valueB = parseFloat(valueB);
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    }

    return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getNestedValue(obj: any, column: string) {
    switch (column) {
      case 'hsfo':
      case 'vlsfo':
      case 'go':
        return obj.bunkerLostOrGain[column.toUpperCase()];
      default:
        return obj[column];
    }
  }
  formatSegment(value: string): string {
    if (!value) return '';

    const trimmed = value.trim().toLowerCase().replace(/\s+/g, ' ');
    const match = trimmed.match(/^([a-z0-9]+)\s*(\(([^)]+)\))?$/i);

    if (match) {
      const main = match[1].toUpperCase(); // e.g., 'LR1', 'MR'
      const bracket = match[3]
        ? ` (${match[3].charAt(0).toUpperCase()}${match[3].slice(1)})`
        : '';
      return main + bracket;
    }

    // Fallback: title case
    return value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }
  showDetails(row: any) {
    const originalImo = row.original_vessel_imo ?? row.vessel_imo;

    const originalVesselName = row.original_vessel_name ?? row.vessel_name;

    localStorage.setItem('pShipName', originalVesselName);
    localStorage.setItem('pImo', String(originalImo));
    localStorage.setItem('pSegment', row.segment || '');
    localStorage.setItem('eyeIcon', 'yes');
    this.router.navigate(['/pc-vesselView']);
  }
  showClaimable(row: any) {
    localStorage.setItem('pShipName', row.vessel_name);
    localStorage.setItem('pImo', row.vessel_imo);
    localStorage.setItem('pSegment', row.segment || '');
    localStorage.setItem('eyeIcon', 'No');
    this.router.navigate(['/pc-vesselView']);
  }
  downloadIcon(ow: any) {
    // this.toastr.success(ToasterMessages.UnderDev);
  }

  editedRowIndex: number | null = null;
  editedColumnName: string | null = null;
  editCell(rowIndex: number, columnName: string) {
    this.editedRowIndex = rowIndex;
    this.editedColumnName = columnName;
  }
  exitEdit() {
    this.editedRowIndex = null;
    this.editedColumnName = null;
  }
  calculateClaimableAmount(element: any) {
    const claimEst = element.claimEst;
    const fuelLost = element.bunkerLostOrGain;

    if (
      claimEst === null ||
      claimEst === undefined ||
      claimEst.hire === '' ||
      claimEst.bunkPrice === ''
    ) {
      return '__';
    }
    const HSFO = fuelLost && fuelLost.HSFO === '__' ? 0 : fuelLost.HSFO;
    const VLSFO = fuelLost && fuelLost.VLSFO === '__' ? 0 : fuelLost.VLSFO;
    const GO = fuelLost && fuelLost.GO === '__' ? 0 : fuelLost.GO;
    const bunkPrice =
      claimEst && claimEst.bunkPrice !== null ? claimEst.bunkPrice : 0;
    const hireClaim = claimEst ? claimEst.hire * (element.timeLost / 24) : 0;
    const fuelClaim = fuelLost
      ? bunkPrice * (HSFO || 0) +
        bunkPrice * (VLSFO || 0) +
        bunkPrice * (GO || 0)
      : 0;

    const totalClaim = hireClaim + fuelClaim;

    return isNaN(totalClaim) || totalClaim === undefined
      ? '__'
      : Math.round(totalClaim);
  }

  // filterClick() {
  //   let { segment, shipName, imoNumber, client } = this.filterForm.value;

  //   segment = segment?.trim().toLowerCase();
  //   shipName = shipName?.trim().toLowerCase();
  //   imoNumber = imoNumber?.trim().toLowerCase();
  //   client = client?.trim().toLowerCase();

  //   this.filteredData = this.elements.filter((item: any) => {
  //     const segmentMatch = segment
  //       ? item.segment?.toLowerCase() === segment
  //       : true;

  //     const shipMatch = shipName
  //       ? item.vessel_name?.toLowerCase().includes(shipName)
  //       : true;

  //     const imoMatch = imoNumber
  //       ? item.vessel_imo?.toLowerCase().includes(imoNumber)
  //       : true;

  //     const clientMatch = client
  //       ? item.client?.toLowerCase().includes(client)
  //       : true;

  //     return segmentMatch && shipMatch && imoMatch && clientMatch;
  //   });

  //   // Update pagination based on filtered data
  //   const startIndex = this.currentPage * this.itemsPerPage;
  //   const pageItems = this.filteredData.slice(
  //     startIndex,
  //     startIndex + this.itemsPerPage
  //   );

  //   this.paginatedData = pageItems.map((item: any, index: number) => ({
  //     ...item,
  //     sNo: startIndex + index + 1,
  //   }));
  // }
  filterClick() {
    this.applyFilters(true);
  }

  private applyFilters(resetPaginator: boolean) {
    localStorage.setItem(
      'vesselFilters',
      JSON.stringify(this.filterForm.value),
    );
    this.refreshFleetView(resetPaginator);
  }

  /** Apply form filters + client selection + At Port/Sea (map + table stay in sync). */
  private refreshFleetView(resetPaginator: boolean) {
    const formFiltered = this.getFormFilteredRows();
    const clientShips = this.getClientFilteredShips();
    const aisReady = Array.isArray(this.allShips) && this.allShips.length > 0;

    if (aisReady) {
      this.ships = this.getNavStatusFilteredShips(clientShips);

      const imoSet = new Set(
        this.ships
          .map((ship: any) =>
            String(
              ship.vesselIMO ??
                ship.vessel_imo ??
                ship.imo ??
                ship.vessel_id ??
                '',
            ),
          )
          .filter(Boolean),
      );

      const allAisImos = new Set(
        (this.allShips || [])
          .map((ship: any) =>
            String(
              ship.vesselIMO ??
                ship.vessel_imo ??
                ship.imo ??
                ship.vessel_id ??
                '',
            ),
          )
          .filter(Boolean),
      );

      this.filteredData = formFiltered.filter((row: any) => {
        const rowImo = String(
          row.original_vessel_imo ??
            row.vessel_imo ??
            row.imo ??
            row.vessel_id ??
            '',
        );

        return imoSet.has(rowImo) || !allAisImos.has(rowImo);
      });
    } else {
      this.ships = clientShips;
      this.filteredData = formFiltered;
    }

    if (resetPaginator) {
      this.currentPage = 0;
      this.paginator?.firstPage();
    }

    this.paginateData();
    this.initMarkers();
  }

  private getSelectedClientNorms(): string[] {
    return (this.selectedClients || [])
      .map((c) => this.normalizeClient(c))
      .filter(Boolean);
  }

  private getFormFilteredRows(): any[] {
    const elements = Array.isArray(this.elements) ? this.elements : [];
    let { shipName, imoNumber } = this.filterForm.value || {};

    shipName = shipName?.trim().toLowerCase();
    imoNumber = imoNumber?.trim().toLowerCase();
    const selectedClientNorms = this.getSelectedClientNorms();

    return elements.filter((item: any) => {
      const segmentMatch =
        this.selectedSegments.length === 0 ||
        this.selectedSegments.some(
          (seg) => item.segment?.toLowerCase() === seg.trim().toLowerCase(),
        );
      const shipMatch = shipName
        ? item.vessel_name?.toLowerCase().includes(shipName)
        : true;
      const imoMatch = imoNumber
        ? String(item.vessel_imo ?? '')
            .toLowerCase()
            .includes(imoNumber)
        : true;
      const clientMatch =
        selectedClientNorms.length > 0
          ? selectedClientNorms.includes(
              this.normalizeClient(item.client || item.clientName || ''),
            )
          : true;
      return segmentMatch && shipMatch && imoMatch && clientMatch;
    });
  }

  private getClientFilteredShips(): any[] {
    const source =
      Array.isArray(this.allShips) && this.allShips.length
        ? this.allShips
        : Array.isArray(this.positions)
          ? this.positions
          : [];
    const selectedClientNorms = this.getSelectedClientNorms();
    if (!selectedClientNorms.length) {
      return [...source];
    }
    return source.filter((item: any) =>
      selectedClientNorms.includes(
        this.normalizeClient(
          item.client_name || item.client || item.clientName || '',
        ),
      ),
    );
  }

  private getNavStatusFilteredShips(ships: any[]): any[] {
    const portStatuses = [1, 5, 6];
    return (ships || []).filter((ship: any) => {
      const navStatus = Number(ship.AIS?.NAV_STATUS);
      const isAtPort = portStatuses.includes(navStatus);
      return this.isAtPortView ? isAtPort : !isAtPort;
    });
  }

  exportClick() {
    const data = this.filteredData || this.elements;
    if (!data.length) return;

    const firstItem = data[0];
    const shipName = firstItem.vessel_name || 'UnknownShip';
    const segment = firstItem.segment || 'UnknownSegment';

    const csvHeader = [
      'Sr No',
      'Vessel Name',
      'IMO No',
      'Client',
      'Segment',
      'Warranty Variance (MT)',
      'Technical Variance (MT)',
      'CP Gain/Loss (MT)',
      'Technical Gain/Loss (MT)',
    ].join(',');

    const csvRows = data.map((item: any, index: number) => {
      return [
        index + 1,
        item.vessel_name || '',
        item.vessel_imo || '',
        item.client || '',
        this.formatSegment(item.segment) || '',
        this.getWarrantyVariance(item).toFixed(2),
        this.getTechnicalVariance(item).toFixed(2),
        this.getTotalWarrantedConsumption(item),
        this.getTotalDesignConsumption(item),
      ]
        .map((field) => `"${field}"`)
        .join(',');
    });

    const csvContent = `${csvHeader}\n${csvRows.join('\n')}`;
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Fleet_View.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  downloadClick() {
    // this.toastr.success(ToasterMessages.UnderDev);
  }
  tabChanged(event: MatTabChangeEvent) {
    // this.selectedTab = !this.selectedTab;
    // if (this.pastVoyagesComponent) {
    //   this.pastVoyagesComponent.refresh();
    // }
  }
  editClick() {
    // this.toastr.warning(ToasterMessages.UnderDev);
    this.edit = true;
  }

  selectedElement: any = null;

  onCheckboxChange(event: Event, element: any) {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;

    if (this.selectedElement && this.selectedElement !== checkbox) {
      this.selectedElement.checked = false;
    }

    if (isChecked) {
      this.selectedElement = checkbox;

      const dialogRef = this.dialog.open(VesselStatusPopupComponent, {
        width: '400px',
        height: '228px',
        disableClose: true,
        data: { reasonOptions: 'True' },
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          const payload = {
            vessel_name: element.vessel_name,
            imo: element.vessel_imo,
            reason: result.reason,
            status: result.status,
          };

          this.prequestFormService.updateStatus(payload).subscribe(
            () => {
              this.edit = false;
              this.toastr.success(ToasterMessages.SuccessMessage);
              this.loadData();
            },
            (error: any) => {
              this.toastr.error('Error updating status. Please try again.');
              console.error('Update error:', error);
            },
          );
        } else {
          // If the dialog is closed without selecting a value, uncheck the checkbox
          checkbox.checked = false;
          this.selectedElement = null;
        }
      });
    } else {
      this.selectedElement = null;
    }
  }
  private toNum(value: unknown): number {
    if (value == null || value === '') {
      return 0;
    }
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }

  /** Warranty variance — top-level total, else manoeuvring + idle + cargo ops. */
  getWarrantyVariance(element: any): number {
    const total = this.toNum(element?.performance_against_warranties);
    if (total !== 0) {
      return total;
    }
    const fromParts =
      this.toNum(element?.maneuvering_performance_against_warranties_mt) +
      this.toNum(element?.idle_performance_against_warranties_mt) +
      this.toNum(element?.cargo_ops_performance_against_warranties_mt);
    return fromParts !== 0 ? fromParts : total;
  }

  /** Technical variance — top-level total, else manoeuvring + idle + cargo ops. */
  getTechnicalVariance(element: any): number {
    const total = this.toNum(element?.performance_against_design);
    if (total !== 0) {
      return total;
    }
    const fromParts =
      this.toNum(element?.maneuvering_performance_against_design_mt) +
      this.toNum(element?.idle_performance_against_design_mt) +
      this.toNum(element?.cargo_ops_performance_against_design_mt);
    return fromParts !== 0 ? fromParts : total;
  }

  getTotalWarrantedConsumption(element: any): string {
    return this.getCpLossGainTotal(element).toFixed(2);
  }
  getTotalDesignConsumption(element: any) {
    return this.getTechnicalLossGainTotal(element).toFixed(2);
  }

  private getCpLossGainTotal(element: any): number {
    const flat =
      this.toNum(element?.cp_warranted_loss_or_gain_hsfo) +
      this.toNum(element?.cp_warranted_loss_or_gain_lsgo) +
      this.toNum(element?.cp_warranted_loss_or_gain_vlsfo);
    if (flat !== 0) {
      return flat;
    }

    const nested =
      element?.cp_warrantedloss_or_gain_mt ||
      element?.cp_warranted_loss_or_gain_mt ||
      {};
    const nestedAlt = element?.cp_warrantedloss_or_gain || {};

    return (
      this.toNum(nested.hsfo ?? nestedAlt.cp_warrantedloss_or_gain_mt__hsfo) +
      this.toNum(nested.vlsfo ?? nestedAlt.cp_warrantedloss_or_gain_mt__vlsfo) +
      this.toNum(nested.lsgo ?? nestedAlt.cp_warrantedloss_or_gain_mt__lsgo)
    );
  }

  private getTechnicalLossGainTotal(element: any): number {
    const flat =
      this.toNum(element?.technical_design_loss_or_gain_hsfo) +
      this.toNum(element?.technical_design_loss_or_gain_lsgo) +
      this.toNum(element?.technical_design_loss_or_gain_vlsfo);
    if (flat !== 0) {
      return flat;
    }

    const nested =
      element?.technical_designloss_or_gain_mt ||
      element?.technical_design_loss_or_gain_mt ||
      {};
    const nestedAlt = element?.technical_designloss_or_gain || {};

    return (
      this.toNum(
        nested.hsfo ?? nestedAlt.technical_designloss_or_gain_mt_hsfo,
      ) +
      this.toNum(
        nested.vlsfo ?? nestedAlt.technical_designloss_or_gain_mt_vlsfo,
      ) +
      this.toNum(nested.lsgo ?? nestedAlt.technical_designloss_or_gain_mt_lsgo)
    );
  }

  getCpLossGainStyle(element: any): { [klass: string]: string } {
    const total = this.getCpLossGainTotal(element);
    return {
      color: total < 0 ? '#ff9090' : total > 0 ? '#a8d296' : 'inherit',
    };
  }

  getTechnicalLossGainStyle(element: any): { [klass: string]: string } {
    const total = this.getTechnicalLossGainTotal(element);
    return {
      color: total < 0 ? '#ff9090' : total > 0 ? '#a8d296' : 'inherit',
    };
  }

  getWarrantedStyle(element: any): { [klass: string]: any } {
    const total = this.getWarrantyVariance(element);
    return {
      color: total < 0 ? '#ff9090' : total > 0 ? '#a8d296' : 'null',
    };
  }
  getTotalDesignStyle(element: any) {
    const total = this.getTechnicalVariance(element);

    return {
      color: total < 0 ? '#ff9090' : total > 0 ? '#a8d296' : 'null',
    };
  }

  getWarrantedTooltip(element: any): string {
    return (
      `Maneuvering: ${this.toNum(
        element.maneuvering_performance_against_warranties_mt,
      ).toFixed(2)}\n` +
      `Idle: ${this.toNum(element.idle_performance_against_warranties_mt).toFixed(2)}\n` +
      `Cargo Ops: ${this.toNum(
        element.cargo_ops_performance_against_warranties_mt,
      ).toFixed(2)}`
    );
  }

  getDesignTooltip(element: any): string {
    return (
      `Maneuvering: ${this.toNum(
        element.maneuvering_performance_against_design_mt,
      ).toFixed(2)}\n` +
      `Idle: ${this.toNum(element.idle_performance_against_design_mt).toFixed(2)}\n` +
      `Cargo Ops: ${this.toNum(
        element.cargo_ops_performance_against_design_mt,
      ).toFixed(2)}`
    );
  }
  formatVesselName(name: string): string {
    if (!name) return '';

    return name
      .toLowerCase()
      .split(' ')
      .filter((word) => word.trim().length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  private segmentColorMap: { [key: string]: string } = {
    mr: '#c27036',
    handymax: '#369047',
    suezmax: '#6a6a6a',
    vlcc: '#3249d4',
    aframax: '#7e3b3b',
    'gas tanker': '#5b5418',
    handy: '#35707b',
    lr1: '#2a644f',
    lr2: '#556ba6',
    coaster: '#859914ff',
    handysize: '#541e85',
    supramax: '#6b181f',
    ultramax: '#85501c',
    panamax: '#723768',
    kamsarmax: '#077c5f',
    'ultra panamax': '',
    capesize: '#7c7440',
    chinamax: '',
    'lr1/panamax': '#42bfaaff',
    'lr2/aframax': '#427ebf',
    'lr3/suezmax': '#bf4281ff',
  };

  getDynamicSegmentStyle(segment: string): any {
    if (!segment) return {};

    const key = segment.toLowerCase();

    // If NOT in static mapping → assign dynamic color
    if (!this.segmentColorMap[key]) {
      this.segmentColorMap[key] = this.generateDarkColorFromText(key);
    }

    const color = this.segmentColorMap[key];

    return {
      'background-color': color,
      'border-radius': '12px',
      padding: '0px 6px',
      color: '#fff',
      display: 'inline-block',
      'font-weight': '500',
      'text-transform': 'uppercase',
      'font-size': '12px',
      'letter-spacing': '0.5px',
    };
  }

  /** Generates a consistent dark color for unknown segments */
  private generateDarkColorFromText(text: string): string {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    let r = (hash >> 16) & 0xff;
    let g = (hash >> 8) & 0xff;
    let b = hash & 0xff;

    // Force dark tones
    r = Math.floor(r * 0.4);
    g = Math.floor(g * 0.4);
    b = Math.floor(b * 0.4);

    return `rgb(${r}, ${g}, ${b})`;
  }

  initMap(): void {
    this.map = L.map('pcFleetMap', {
      center: [34.553127, 18.048012],
      zoom: 2,
      minZoom: 2,
      zoomControl: true,
      attributionControl: false,
    });

    this.baseLayer = L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    ).addTo(this.map);

    this.prequestFormService.getVesselPosition().subscribe({
      next: (data: any) => {
        this.positions = data.data || [];
        if (this.subusername?.toLowerCase() === 'demo') {
          this.positions = this.positions
            .filter((item: any) =>
              DEMO_VESSEL_PC.includes(
                String(item.vesselIMO ?? item.imo ?? item.vessel_imo),
              ),
            )
            .map((item: any) => {
              const originalImo = String(
                item.vesselIMO ?? item.imo ?? item.vessel_imo,
              );

              return {
                ...item,
                originalVesselIMO: originalImo,
                displayVesselIMO: 'XXXXXXX',
                displayVesselName:
                  originalImo === '9399480' ? 'Vessel 1' : 'Vessel 2',
              };
            });
        }

        if (this.positions?.length) {
          const clientFilters: { [key: string]: (item: any) => boolean } = {
            'Eiger Shipping': (item) =>
              (item.client_name || '').toLowerCase().includes('client'),

            'Zeronorth ZN': (item) =>
              (item.client_name || '').toLowerCase().includes('zeronorth'),

            'Elite Shipping': (item) => {
              const name = (item.client_name || '').toLowerCase();
              return name.includes('elite');
            },

            'Bunge Shipping': (item) =>
              (item.client_name || '').toLowerCase().includes('bunge'),

            'Alcor Shipping': (item) =>
              (item.client_name || '')
                .toLowerCase()
                .includes('alcor chartering'),

            'EMZoil Shipping': (item) =>
              (item.client_name || '').toLowerCase().includes('emz'),

            'Ethiopian Shipping & Logistics': (item) =>
              (item.client_name || '').toLowerCase() ===
              'ethiopian shipping & logistics',
          };

          // client wise filtering
          if (this.username && this.username !== 'Meraki - Operations') {
            if (clientFilters[this.username]) {
              this.ships = this.positions.filter(clientFilters[this.username]);
            } else {
              this.ships = this.positions;
            }
          } else {
            this.ships = this.positions;
          }
          if (this.subusername?.toLowerCase() === 'grace') {
            this.ships = this.ships?.filter(
              (item: any) =>
                String(item.vesselIMO ?? item.imo ?? item.vessel_imo) !==
                '9397456',
            );
          }
          // final positions set
          this.positions = this.ships;

          // AIS merge call
          this.getAisData();
        }
      },
      error: () => {
        this.positions = [];
        this.ships = [];
      },
    });
  }
  initMarkers(): void {
    this.markers.forEach((marker) => marker.remove()); // Clear existing markers if any
    this.addMarkers();
  }
  addMarkers(): void {
    this.markers.forEach((marker) => marker.remove());
    this.markers = [];

    const navStatusMap: Record<number, string> = {
      0: 'Under Way',
      1: 'At Anchor',
      2: 'Not Under Command',
      3: 'Restricted Manoeuvrability',
      5: 'Moored',
    };

    const latestVessels: any = {};

    this.ships.forEach((item: any) => {
      const ais = item.AIS;

      const lat = ais?.LATITUDE
        ? Number(ais.LATITUDE)
        : Number(item.latitudeResult);

      const lng = ais?.LONGITUDE
        ? Number(ais.LONGITUDE)
        : Number(item.longitudeResult);

      if (!lat || !lng) return;

      const vessel = item.vesselName;
      const time = new Date(item.report_timestamp).getTime();

      if (
        !latestVessels[vessel] ||
        new Date(latestVessels[vessel].report_timestamp).getTime() < time
      ) {
        latestVessels[vessel] = {
          ...item,
          latitudeResult: lat,
          longitudeResult: lng,
          heading: ais?.HEADING,
          cog: ais?.COG,
          navStatus: ais?.NAV_STATUS,
          eta: ais?.ETA,
          speed: ais?.SPEED,
          vesselType: ais?.VESSEL_TYPE,
          draught: ais?.DRAUGHT,
          destination: ais?.DESTINATION,
          last_updated: ais?.TIMESTAMP,
        };
      }
    });

    Object.values(latestVessels).forEach((res: any) => {
      const heading = res.AIS?.HEADING || res.AIS?.COG || 0;
      const displayName =
        this.subusername?.toLowerCase() === 'demo'
          ? res.displayVesselName
          : res.vesselName;
      const marker = L.marker([res.latitudeResult, res.longitudeResult], {
        icon: this.createIcon(
          res.condition,
          displayName?.toUpperCase(),
          this.map.getZoom(),
          res.AIS?.isLive,
          heading,
        ),
      });

      const signalOld =
        Date.now() - new Date(res.AIS?.TIMESTAMP || Date.now()).getTime() >
        21600000;
      const popup = `
      <div class="vessel-popup-card">
        <div class="popup-title">
          🚢 ${displayName || 'NA'}
         
        </div>

        <div class="popup-grid">
          <div><i class="fa-solid fa-location-crosshairs icon-light"></i> Destination</div>
          <div>${res.destination || 'NA'}</div>

          <div><i class="fa-regular fa-clock"></i> ETA (UTC)</div>
          <div>${res.eta || 'NA'}</div>

          <div><i class="fa-solid fa-anchor"></i> Status</div>
          <div>${this.getNavStatusLabel(res.navStatus)}</div>

          <div><i class="fa-solid fa-gauge icon-light"></i> Speed(SOG)</div>
          <div>${res.speed ?? 'NA'} knots</div>

          <div><i class="fa-solid fa-compass"></i> Direction(COG)</div>
          <div>${this.formatCOG(res.cog)}</div>

          <div><i class="fa-solid fa-arrow-down"></i> Depth</div>
          <div>${res.draught ?? 'NA'} m</div>

          <div><i class="fa-solid fa-location-dot"></i> Coordinates</div>
          <div>
            ${this.formatLatLng(res.latitudeResult, 'lat')},
            ${this.formatLatLng(res.longitudeResult, 'lng')}
          </div>

          <div><i class="fa-regular fa-clock"></i> UTC Time</div>
          <div>
            ${res.last_updated || 'NA'}
            ${res.last_updated ? this.getTimeAgo(res.last_updated) : ''}
          </div>
        </div>
      </div>
    `;

      marker.bindPopup(popup, {
        closeButton: false,
        offset: [0, -5],
        autoPan: false,
        className: 'vessel-popup',
      });

      marker.on('mouseover', () => marker.openPopup());
      marker.on('mouseout', () => marker.closePopup());

      marker.addTo(this.map);
      this.markers.push(marker);

      marker.addTo(this.map);
      this.markers.push(marker);
    });
  }
  getIconSize(zoomLevel: number): number {
    return Math.min(Math.max(zoomLevel * 2, 12), 40);
  }
  createIcon(
    voyageType: string,
    shipName: string,
    zoomLevel: number,
    isLive: boolean,
    heading: number = 0,
  ): L.DivIcon {
    const size = this.getIconSize(zoomLevel) + 6;
    const isBallast = voyageType === 'Ballast';

    const hullColor = isBallast ? '#ff7a00' : '#7C2020';
    // ✅ AIS alignment fix
    const rotation = (heading || 0) + 90;

    return L.divIcon({
      className: 'realistic-vessel-icon',
      html: `
      <div style="
        display:flex;
        flex-direction:column;
        align-items:center;
        transform:translateY(-8px);
        position:relative;
      ">
  
        ${
          isLive
            ? `<div class="live-vessel-glow" style="
                width:${size}px;
                height:${size}px;
                position:absolute;
                border-radius:50%;
                background:rgba(34,197,94,0.7);
                box-shadow:0 0 20px rgba(34,197,94,0.9);
                z-index:1;
              "></div>`
            : ''
        }
  
        <!-- YOUR EXACT SHIP SHAPE + ROTATION -->
        <svg
          width="${size * 1.6}"
          height="${size * 0.8}"
          viewBox="0 0 100 40"
          style="
            z-index:2;
            transform: rotate(${rotation}deg);
            transform-origin: 50% 50%;
            transition: transform 0.3s linear;
            filter: drop-shadow(0 3px 6px rgba(0,0,0,0.4));
          "
        >
          <polygon points="0,20 15,5 15,35" fill="${hullColor}"/>
          <rect x="15" y="8" width="55" height="24" fill="${hullColor}"/>
          <rect x="70" y="10" width="20" height="20"
            fill="white" stroke="${hullColor}" stroke-width="2"/>
          <rect x="90" y="12" width="6" height="16" fill="${hullColor}"/>
        </svg>
  
        <div style="
          margin-top:-3px;
          padding:3px 9px;
          font-size:10px;
          font-weight:700;
          color:#ffffff;
          background:#192a4c;
          border-radius:14px;
          white-space:nowrap;
          box-shadow:0 2px 6px rgba(0,0,0,0.35);
        ">
          ${shipName || 'NA'}
        </div>
  
        ${
          isLive
            ? `<div style="
                  margin-top:2px;
                  font-size:9px;
                  color:#22c55e;
                  font-weight:700;
                ">LIVE</div>`
            : ''
        }
  
      </div>
      `,
      iconSize: [size * 1.8, size],
      iconAnchor: [size * 0.9, size / 2],
    });
  }
  shipMarkers: {
    marker: L.Marker;
    data: any;
  }[] = [];

  getTimeAgo(timestamp: string): string {
    if (!timestamp) return '';

    const updatedTime = new Date(timestamp).getTime();
    const now = new Date().getTime();

    const diffMs = now - updatedTime;

    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));

    if (minutes < 1) return '(just now)';
    if (minutes < 60) return `(${minutes} min ago)`;
    if (hours < 24) return `(${hours} hr ago)`;

    const days = Math.floor(hours / 24);
    return `(${days} day${days > 1 ? 's' : ''} ago)`;
  }

  onFleetViewToggle() {
    this.router.navigate(['/vp-fleetView']);
  }

  isAtPortView = true;
  allShips: any[] = [];
  allFilteredData: any[] = [];

  setView(atPort: boolean) {
    this.isAtPortView = atPort;
    this.refreshFleetView(true);
  }

  normalizeLongitude(currentLng: number, previousLng: number): number {
    let diff = currentLng - previousLng;

    if (diff > 180) {
      currentLng -= 360;
    } else if (diff < -180) {
      currentLng += 360;
    }

    return currentLng;
  }
  getDirection(deg: number): string {
    if (deg == null) return '';

    const dirs = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
    return dirs[Math.round(deg / 45) % 8];
  }

  formatCOG(cog: number): string {
    if (cog == null) return 'NA';
    return `${cog}° (${this.getDirection(cog)})`;
  }
  formatROT(rot: number): string {
    if (rot == null) return 'NA';
    if (rot === 0) return 'Straight';

    return rot > 0 ? `Right (${rot})` : `Left (${rot})`;
  }
  formatLatLng(value: number, type: 'lat' | 'lng'): string {
    if (value === null || value === undefined) return 'NA';

    const abs = Math.abs(value).toFixed(2);

    if (type === 'lat') {
      return `${abs}° ${value >= 0 ? 'N' : 'S'}`;
    } else {
      return `${abs}° ${value >= 0 ? 'E' : 'W'}`;
    }
  }

  getNavStatusLabel(status: number): string {
    const map: any = {
      0: 'Under way',
      1: 'At anchor',
      2: 'Not under command',
      3: 'Restricted maneuverability',
      4: 'Constrained by draught',
      5: 'Moored',
      6: 'Aground',
      7: 'Fishing',
      8: 'Moving under sail',
    };
    return map[status] || 'Unknown';
  }

  formatCourse(cog: number): string {
    if (cog == null) return 'NA';
    return `${cog}°`;
  }

  formatHeading(heading: number): string {
    if (heading == null) return 'NA';
    return `${heading}° (${this.getDirection(heading)})`;
  }
}
